export const CALL_START = "callStart";
export const CALL_END = "callEnd";
export const CALL_FAIL = "callFail";

// General Data Store mutations
export const SET_PAYLOAD = "setPayloadData";
export const SET_INVOICE_DATA = "setInvoiceData";
export const SET_INVOICE_EDITABLE = "setInvoiceEditableStatus";
export const SET_BILLING_INFO = "setBillingInfoData";
export const SET_STASH_DATA = "setStashedCardData";
export const SET_PAYMENT_DETAILS = "setPaymentDetailsData";
export const SET_PAYMENT_METHOD = "setPaymentMethodData";
export const SET_INVOICE_CACHE = "setInvoiceCache";

// Clear / Wipe data
export const CLEAR_STASH = "clearStashData";
export const CLEAR_INVOICE = "clearInvoiceData";
export const CLEAR_BILLING = "clearBillingData";
export const CLEAR_PAYMENT = "clearPaymentData";
export const CLEAR_INVOICE_CACHE = "clearInvoiceCache";

// Checkout API mutations
export const STORE_PAYMENT_METHODS = "storePaymentMethods";
export const CLEAR_PAYMENT_METHODS_RESOLVE = "clearPaymentMethodsResolve";
export const STORE_RATES = "storeRateOfferResolve";
export const CLEAR_RATES_RESOLVE = "clearRateOfferResolve";
export const STORE_FINGERPRINT = "storeFingerprint";
export const STORE_MERCHANT_CURRENCY = "storeMerchantCurrency";
export const STORE_CUSTOMER_CURRENCY = "storeCustomerCurrency";
export const SET_ACTION = "storeRequiredAction";
export const SET_ORDER_ID = "storeOrderId";
export const SET_ISSUER_ID = "storeIssuerId";
export const SET_FINANCING_OPTION = "storeFinancingOptionSelected";

// Merchant mutations
export const RESOLVE_MERCHANT_INFO = "resolveMerchantInfo";
export const RESOLVE_BADGE_INFO = "resolveBadgeInfo";
export const RESOLVE_RATE_LIST = "resolveRateList";

// Auth stuff
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setAccessToken";
export const SET_ERROR = "setError";
